import { render, staticRenderFns } from "./WorkshopsOverview.vue?vue&type=template&id=846c5ef6&scoped=true&"
import script from "./WorkshopsOverview.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846c5ef6",
  null
  
)

export default component.exports